// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyLibrary_export-center-page__p16zh {
  background: var(--background-color-1, #f5f7fa);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: var(--font-body, "Inter", sans-serif);
}

.MyLibrary_export-container__fSmSV {
  flex: 1 1;
  background-color: #ffffff;
  margin: 0 40px 40px;
  border-radius: 8px;
  border: 1px solid var(--border-color, #e5e7eb);
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.MyLibrary_export-header__rKFgd {
  padding: 40px 40px 20px;
  width: 100%;
}

.MyLibrary_export-header-inner__ypqRk {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.MyLibrary_export-header-title__rVhtA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.MyLibrary_export-header-title__rVhtA h1 {
  text-align: center;
  color: var(--accent-color, #0f3460);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}
.MyLibrary_export-header-title__rVhtA p {
  color: var(--grey-text, #666666);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
  max-width: 800px;
}

.MyLibrary_overview-strip__Soq56 {
  display: flex;
  gap: 24px;
  background-color: #ffffff;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  padding: 16px 24px;
}

.MyLibrary_overview-metric__tvRFd {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.MyLibrary_overview-metric__tvRFd .MyLibrary_metric-label__q-HCb {
  font-size: 13px;
  color: var(--text-3, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
}
.MyLibrary_overview-metric__tvRFd .MyLibrary_metric-value__uqvpy {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color, #111827);
}

.MyLibrary_export-toolbar__PnY-s {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.MyLibrary_toolbar-filters__lgd1v {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MyLibrary_export-list-container__FqeKi {
  background-color: #ffffff;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  overflow: hidden;
}
.MyLibrary_export-list-container__FqeKi .ant-table {
  font-size: 14px;
}
.MyLibrary_export-list-container__FqeKi .ant-table-thead > tr > th {
  background-color: #f9fafb;
  color: var(--text-3, #6b7280);
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  padding: 12px 16px;
}
.MyLibrary_export-list-container__FqeKi .ant-table-tbody > tr > td {
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  padding: 16px;
}
.MyLibrary_export-list-container__FqeKi .ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

.MyLibrary_status-badge__CJuVZ {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  text-transform: capitalize;
}
.MyLibrary_status-badge__CJuVZ.MyLibrary_completed__6VZuh, .MyLibrary_status-badge__CJuVZ.MyLibrary_ready__TuYp6 {
  background-color: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}
.MyLibrary_status-badge__CJuVZ.MyLibrary_processing__zlYJf, .MyLibrary_status-badge__CJuVZ.MyLibrary_pending__Mtsh4, .MyLibrary_status-badge__CJuVZ.MyLibrary_queued__sVWHX {
  background-color: #eff6ff;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}
.MyLibrary_status-badge__CJuVZ.MyLibrary_failed__8WJy\\+ {
  background-color: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}
.MyLibrary_status-badge__CJuVZ.MyLibrary_expired__\\+mnKZ {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}

.MyLibrary_action-btn__nHFnO {
  background: none;
  border: none;
  color: var(--explore-color, #0f3460);
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}
.MyLibrary_action-btn__nHFnO:hover:not(:disabled) {
  background-color: rgba(15, 52, 96, 0.08);
}
.MyLibrary_action-btn__nHFnO:disabled {
  color: var(--text-4, #9ca3af);
  cursor: not-allowed;
}
.MyLibrary_action-btn__nHFnO.MyLibrary_danger__hOreR {
  color: #dc2626;
}
.MyLibrary_action-btn__nHFnO.MyLibrary_danger__hOreR:hover:not(:disabled) {
  background-color: #fef2f2;
}

.MyLibrary_detail-row__xoJiA {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 24px;
}
.MyLibrary_detail-row__xoJiA .MyLibrary_detail-label__xg5EX {
  font-size: 13px;
  color: var(--text-3, #6b7280);
  font-weight: 500;
}
.MyLibrary_detail-row__xoJiA .MyLibrary_detail-value__aO3Wb {
  font-size: 14px;
  color: var(--text-color, #111827);
}

@media (max-width: 768px) {
  .MyLibrary_export-header__rKFgd {
    padding: 24px;
  }
  .MyLibrary_export-container__fSmSV {
    padding: 0 24px 24px;
  }
  .MyLibrary_overview-strip__Soq56 {
    flex-wrap: wrap;
  }
  .MyLibrary_export-toolbar__PnY-s {
    flex-direction: column;
    align-items: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/MyLibrary/MyLibrary.module.scss"],"names":[],"mappings":"AACA;EACE,8CAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;AAAF;;AAGA;EACE,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAIA;EACE,uBAAA;EACA,WAAA;AADF;;AAIA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AADF;AAGE;EACE,kBAAA;EACA,mCAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAIE;EACE,gCAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAFJ;;AAOA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,8CAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;AAME;EACE,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;AALJ;;AAUA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPF;;AAWA;EACE,yBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AARF;AAUE;EACE,eAAA;AARJ;AAWE;EACE,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,qDAAA;EACA,kBAAA;AATJ;AAYE;EACE,qDAAA;EACA,aAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AAbF;AAeE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAdJ;AAiBE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAhBJ;;AAqBA;EACE,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;AAoBE;EACE,wCAAA;AAlBJ;AAqBE;EACE,6BAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,cAAA;AApBJ;AAqBI;EACE,yBAAA;AAnBN;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAtBF;AAwBE;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,iCAAA;AAvBJ;;AA2BA;EACE;IACE,aAAA;EAxBF;EA0BA;IACE,oBAAA;EAxBF;EA0BA;IACE,eAAA;EAxBF;EA0BA;IACE,sBAAA;IACA,oBAAA;EAxBF;AACF","sourcesContent":["// Doc-Ref: docs/features/collaborations-plan.md\n.export-center-page {\n  background: var(--background-color-1, #f5f7fa);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-body, \"Inter\", sans-serif);\n}\n\n.export-container {\n  flex: 1;\n  background-color: #ffffff;\n  margin: 0 40px 40px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color, #e5e7eb);\n  padding: 24px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n// Header\n.export-header {\n  padding: 40px 40px 20px;\n  width: 100%;\n}\n\n.export-header-inner {\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.export-header-title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n\n  h1 {\n    text-align: center;\n    color: var(--accent-color, #0f3460);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0;\n  }\n\n  p {\n    color: var(--grey-text, #666666);\n    text-align: center;\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin: 0;\n    max-width: 800px;\n  }\n}\n\n// Overview Strip\n.overview-strip {\n  display: flex;\n  gap: 24px;\n  background-color: #ffffff;\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 8px;\n  padding: 16px 24px;\n}\n\n.overview-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  \n  .metric-label {\n    font-size: 13px;\n    color: var(--text-3, #6b7280);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    font-weight: 500;\n  }\n  \n  .metric-value {\n    font-size: 24px;\n    font-weight: 600;\n    color: var(--text-color, #111827);\n  }\n}\n\n// Toolbar\n.export-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.toolbar-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n// Table / List\n.export-list-container {\n  background-color: #ffffff;\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 8px;\n  overflow: hidden;\n\n  :global(.ant-table) {\n    font-size: 14px;\n  }\n  \n  :global(.ant-table-thead > tr > th) {\n    background-color: #f9fafb;\n    color: var(--text-3, #6b7280);\n    font-weight: 500;\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 0.05em;\n    border-bottom: 1px solid var(--border-color, #e5e7eb);\n    padding: 12px 16px;\n  }\n\n  :global(.ant-table-tbody > tr > td) {\n    border-bottom: 1px solid var(--border-color, #e5e7eb);\n    padding: 16px;\n  }\n\n  :global(.ant-table-tbody > tr:last-child > td) {\n    border-bottom: none;\n  }\n}\n\n// Badges\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  text-transform: capitalize;\n\n  &.completed, &.ready {\n    background-color: #ecfdf5;\n    color: #065f46;\n    border: 1px solid #a7f3d0;\n  }\n  \n  &.processing, &.pending, &.queued {\n    background-color: #eff6ff;\n    color: #1e40af;\n    border: 1px solid #bfdbfe;\n  }\n  \n  &.failed {\n    background-color: #fef2f2;\n    color: #991b1b;\n    border: 1px solid #fecaca;\n  }\n  \n  &.expired {\n    background-color: #f3f4f6;\n    color: #374151;\n    border: 1px solid #e5e7eb;\n  }\n}\n\n// Action Button\n.action-btn {\n  background: none;\n  border: none;\n  color: var(--explore-color, #0f3460);\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  &:hover:not(:disabled) {\n    background-color: rgba(15, 52, 96, 0.08);\n  }\n\n  &:disabled {\n    color: var(--text-4, #9ca3af);\n    cursor: not-allowed;\n  }\n\n  &.danger {\n    color: #dc2626;\n    &:hover:not(:disabled) {\n      background-color: #fef2f2;\n    }\n  }\n}\n\n// Export Detail Drawer\n.detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 24px;\n  \n  .detail-label {\n    font-size: 13px;\n    color: var(--text-3, #6b7280);\n    font-weight: 500;\n  }\n  \n  .detail-value {\n    font-size: 14px;\n    color: var(--text-color, #111827);\n  }\n}\n\n@media (max-width: 768px) {\n  .export-header {\n    padding: 24px;\n  }\n  .export-container {\n    padding: 0 24px 24px;\n  }\n  .overview-strip {\n    flex-wrap: wrap;\n  }\n  .export-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"export-center-page": `MyLibrary_export-center-page__p16zh`,
	"export-container": `MyLibrary_export-container__fSmSV`,
	"export-header": `MyLibrary_export-header__rKFgd`,
	"export-header-inner": `MyLibrary_export-header-inner__ypqRk`,
	"export-header-title": `MyLibrary_export-header-title__rVhtA`,
	"overview-strip": `MyLibrary_overview-strip__Soq56`,
	"overview-metric": `MyLibrary_overview-metric__tvRFd`,
	"metric-label": `MyLibrary_metric-label__q-HCb`,
	"metric-value": `MyLibrary_metric-value__uqvpy`,
	"export-toolbar": `MyLibrary_export-toolbar__PnY-s`,
	"toolbar-filters": `MyLibrary_toolbar-filters__lgd1v`,
	"export-list-container": `MyLibrary_export-list-container__FqeKi`,
	"status-badge": `MyLibrary_status-badge__CJuVZ`,
	"completed": `MyLibrary_completed__6VZuh`,
	"ready": `MyLibrary_ready__TuYp6`,
	"processing": `MyLibrary_processing__zlYJf`,
	"pending": `MyLibrary_pending__Mtsh4`,
	"queued": `MyLibrary_queued__sVWHX`,
	"failed": `MyLibrary_failed__8WJy+`,
	"expired": `MyLibrary_expired__+mnKZ`,
	"action-btn": `MyLibrary_action-btn__nHFnO`,
	"danger": `MyLibrary_danger__hOreR`,
	"detail-row": `MyLibrary_detail-row__xoJiA`,
	"detail-label": `MyLibrary_detail-label__xg5EX`,
	"detail-value": `MyLibrary_detail-value__aO3Wb`
};
export default ___CSS_LOADER_EXPORT___;
